export const VALID_CHART_TYPES = [
  'bar', 'line', 'area', 'pie', 'donut', 'scatter', 'table', 'kpi', 'stackedBar', 'gauge'
];

export function validateChartConfig(config) {
  if (!config || typeof config !== 'object') return null;
  if (!VALID_CHART_TYPES.includes(config.chartType)) return null;
  if (!config.data) return null; // Some charts like KPI might not have normal data array but let's assume data is required

  // If it's a KPI or Gauge, data structure might differ, but ensuring it's an array for consistency
  if (!Array.isArray(config.data)) return null;

  let validatedData = [...config.data];
  if (validatedData.length === 0) return null;

  // Cap frontend data to 100 rows max (safety net)
  if (validatedData.length > 100) {
    validatedData = validatedData.slice(0, 100);
  }

  return {
    ...config,
    data: validatedData,
  };
}
